import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Endpoints } from '../../../../../apis';
import { getErrorMessage } from '@xver/utils/error';

export function useLaunchBaremetalMutate() {
    const { t } = useTranslation('notifications');
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: Endpoints.v1.Baremetals.launchBaremetal,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['api.v1.baremetals.list'] });
            notifications.show({
                title: t('baremetal.launched'),
                message: t('baremetal.launchedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
            navigate('/bare-metal-compute');
        },
        onError: (error: any) => {
            notifications.show({
                title: t('baremetal.launchFailed'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
